<template>

	<div class="panel-body">

		<div class="form-group">
			<div class="col-xs-12">
				<div class="row">
					<label class="col-md-2 control-label mt5">菜单名称</label>
					<div class="col-md-10">
						<input type="text" class="form-control" v-model="menu.name"/>
					</div>
				</div>
			</div>

			<div class="col-xs-12 mt10">
				<div class="row">
					<label class="col-md-2 control-label mt5">菜单类型</label>
					<div class="col-md-10">
						<select class="form-control m-b"
						        name="type" v-model="menu.type">
							<option v-for="type in menu.TypeList" :value="type.value">{{type.name}}</option>
						</select>
					</div>
				</div>
			</div>

			<div class="col-xs-12 mt10" v-if="menu.type === 'ARTICLE' || menu.type === 'PERSON' || menu.type === 'SCENERY' || menu.type === 'PARENT'">
				<div class="row">
					<label class="col-md-2 control-label mt5">访问地址</label>
					<div class="col-md-10">
						<input type="text" class="form-control" v-model="menu.location"/>
					</div>
				</div>
			</div>

			<div class="col-xs-12 mt10" v-if="menu.type === 'ARTICLE'">
				<div class="row">
					<label class="col-md-2 control-label mt5">关联文章</label>
					<div class="col-md-10">
						<ArticlePagerSelection :activeArticle="menu.article"/>
					</div>
				</div>
			</div>

			<div class="col-xs-12 mt10" v-if="menu.type === 'PERSON'">
				<div class="row">
					<label class="col-md-2 control-label mt5">关联人物</label>
					<div class="col-md-10">
						<PersonPagerSelection :activePerson="menu.person"/>
					</div>
				</div>
			</div>

			<div class="col-xs-12 mt10" v-if="menu.type === 'URL'">
				<div class="row">
					<label class="col-md-2 control-label mt5">菜单链接</label>
					<div class="col-md-10">
						<input type="text" class="form-control" v-model="menu.url"/>
					</div>
				</div>
			</div>


			<div class="col-xs-12 mt10" v-if="menu.type === 'TOPIC'">
				<div class="row">
					<label class="col-md-2 control-label mt5">关联专题</label>
					<div class="col-md-10">
						<TopicPagerSelection :activeTopic="menu.topic"/>
					</div>
				</div>
			</div>
			
			<div class="col-xs-12 mt10" v-if="menu.type === 'SCENERY'">
				<div class="row">
					<label class="col-md-2 control-label mt5">关联定制页面</label>
					<div class="col-md-10">
						<SceneryPagerSelection :activeScenery="menu.scenery"/>
					</div>
				</div>
			</div>
			

			<div class="col-xs-12">
				<div class="alert alert-danger mt10 mb0" v-show="menu.errorMessage">
					{{menu.errorMessage}}
				</div>
			</div>


		</div>


	</div>

</template>

<script>
	import TopicMenu from '../../../../common/model/topic/TopicMenu'
	import ArticlePagerSelection from '../../../../backyard/view/article/Selection.vue'
	import PersonPagerSelection from '../../../../backyard/view/person/Selection.vue'
	import TopicPagerSelection from '../../../../backyard/view/topic/Selection.vue'
	import SceneryPagerSelection from '../../../../backyard/view/scenery/Selection.vue'

	export default {
		data(){
			return {}
		},
		props: {
			menu: {
				type: TopicMenu,
				required: true
			},
			container: {
				type: Array,
				required: true
			}

		},
		components: {
			ArticlePagerSelection,
			PersonPagerSelection,
			TopicPagerSelection,
			SceneryPagerSelection
		},
		computed: {},
		watch: {},
		methods: {
			exist(entity){
				for (let j = 0; j < this.container.length; j++) {
					let b = this.container[j];
					if (entity.name === b.name && b.name !== this.menu.name) {
						return true;
					}
				}
				return false;
			}
		},
		mounted(){
		}
	}
</script>


// WEBPACK FOOTER //
// PanelBody.vue?78e670ff